module.exports = __webpack_public_path__ + "static/img/chenlong.fa4ea3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/chenlong.png
// module id = EfU9
// module chunks = 0